import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './index.css';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from "./context/authContext";

import AuthenticationComponent from './pages/AuthenticationComponent';
import AppsListComponent from './pages/AppsListComponent';
import AppComponent from './pages/AppComponent';
import ManageAppComponent from './pages/ManageAppComponent';
import ManageStageComponent from './pages/ManageAppComponent';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';


import DocumentationMainComponent from './components/Documentation/DocumentationMainComponent';
import ClientManagementPage from './pages/ClientManagementPage';
import ProtectedRoute from './components/ProtectedRoute';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import BenchmarkPage from './pages/BenchmarksPage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Navigate to="/authenticate" />}></Route>
          <Route path='/authenticate' element={<AuthenticationComponent />}></Route>
          <Route path='/subscribe' element={<ClientManagementPage />}></Route>
          <Route path='/forgot-password' element={<ForgotPassword />}></Route>
          <Route path='/reset-password' element={<ResetPassword />}></Route>

          <Route
            path='/benchmark'
            element={
              <ProtectedRoute>
                <BenchmarkPage />
              </ProtectedRoute>}>
          </Route>
          <Route
            path='/apps-list'
            element={
              <ProtectedRoute>
                <AppsListComponent />
              </ProtectedRoute>
            }>
          </Route>
          <Route
            path='/app/:id'
            element={
              <ProtectedRoute>
                <AppComponent />
              </ProtectedRoute>
            }>
          </Route>
          <Route
            path='/app/:id/manage'
            element={
              <ProtectedRoute>
                <ManageAppComponent />
              </ProtectedRoute>}>

          </Route>
          <Route
            path='/manage/app'
            element={
              <ProtectedRoute>
                <ManageAppComponent />
              </ProtectedRoute>
            }>

          </Route>
          <Route
            path='/manage/stage'
            element={
              <ProtectedRoute>
                <ManageStageComponent />
              </ProtectedRoute>
            }>
          </Route>
          <Route path='/docs' element={<DocumentationMainComponent />}></Route>
          <Route path='/terms' element={<Terms />}></Route>
          <Route path='/privacy' element={<Privacy />}></Route>
          <Route path="*" element={<p>There's nothing here: 404!</p>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
